<template>
  <div class="download-box-wrap" @click="clickBtnUpload">
    <div class="download-box pc-only">
      <div class="top">
        <div class="left">
          <a
            href="javascript:;"
            class="apple limit-px ib common-download-apple"
            :class="nowLang"
            data-reason="index"
            data-type="appstore"
            :data-link="downloadLink.appstore"
            @click="jumpLink"
          ></a>
          <a
            href="javascript:;"
            class="google limit-px ib common-download-google"
            :class="nowLang"
            data-reason="index"
            data-type="google"
            :data-link="downloadLink.googlePlay"
            @click="jumpLink"
          ></a>
        </div>
        <a
          href="javascript:;"
          v-if="downloadLink.pcPlay"
          class="right j-client-download start-game common-download-pc_big limit-px ib"
          :class="nowLang"
          data-reason="index"
          data-type="pc"
          @click="jumpLink"
        ></a>
      </div>
      <a
        href="javascript:void(0)"
        v-if="showMoreDownload"
        class="bottom moreDownloadWay-px"
        data-reason="index"
        data-type="moreWay"
        @click="showPopup('downloadWay')"
        >{{$t('moreDownload')}} >></a
      >
    </div>
    <a
      :href="isAndroid ? downloadLink.googlePlay : downloadLink.appstore"
      target="_blank"
      class="mobileDownloadBtn ib"
      data-reason="index"
      data-type="download"
    >
      <span class="icon ib" :class="isAndroid ? 'google' : 'mac'"></span>
      <span class="btn-text"> {{ $t('download') }} </span>
    </a>
  </div>
</template>

<script lang="ts" setup>
import gameInfoHook from '@/hooks/gameInfoHook';
import popupHook from '@/hooks/popupHook';
import { nowLang } from "@/language";
import { clickBtnUpload } from '@/utils/pointUtils';
const { isAndroid, downloadLink, jumpLink, showMoreDownload } = gameInfoHook();
const { showPopup } = popupHook();
</script>
